const e = "styles-module__client_details_container___nM43R", t = "styles-module__title___PMN5-", _ = "styles-module__consent_communicate_by_phone___0Xdq2", n = "styles-module__phone_container___mIljx", o = "styles-module__textarea___QJbPR", s = {
  client_details_container: e,
  title: t,
  consent_communicate_by_phone: _,
  phone_container: n,
  textarea: o
};
export {
  e as client_details_container,
  _ as consent_communicate_by_phone,
  s as default,
  n as phone_container,
  o as textarea,
  t as title
};
